import { Controller, useFormContext } from 'react-hook-form'
import { FormInput } from '../../functions/types'
import {
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormGroup,
  Box,
  FormHelperText,
  Typography,
  Select,
  TextField,
  MenuItem
} from '@mui/material'
import { useFormStore } from '../../functions/formStore'
import { isNil } from 'lodash/fp'

const InputForm = (): JSX.Element => {
  const {
    formState: { errors },
    control,
    setValue
  } = useFormContext<FormInput>()

  const { setData, data } = useFormStore()
  console.log(`[index] data`, data)
  console.log(`[index] errors`, errors)

  const no2Options: FormInput["No2"][] = ['男性', '女性', 'その他']
  const no3Options: FormInput["No3"][] = ['カテエネ', 'チラシ', '友人', 'その他']
  const no4Options: FormInput["No4"] = ['同意する']

  return (
    <Box>
      <Box display="grid" justifyContent={"center"} marginY={5}>
        <Typography variant="h6" borderBottom={2} borderColor={"GrayText"} color="gray">アンケート</Typography>
      </Box>
      <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} >
        {/* No1 */}
        <FormControl component="fieldset" margin="normal" required>
          <FormLabel component="legend">お名前</FormLabel>
          <Controller
            name="No1"
            control={control}
            render={({ field }) => (
              <TextField {...field} fullWidth required={true} margin="normal" value={data.No1} inputMode='text' multiline={false} placeholder={`中電 太郎`} onChange={(event) => {
                setData({ ...data, No1: event.target.value })
                setValue("No1", event.target.value, { shouldValidate: true })
              }
              } />
            )}
          />
          <FormHelperText error>{errors.No1?.message}</FormHelperText>
        </FormControl>

        {/* No2 */}
        <FormControl component="fieldset" margin="normal" required>
          <FormLabel component="legend">性別</FormLabel>
          <Controller
            name="No2"
            control={control}
            render={({ field }) => (
              <RadioGroup {...field}>
                {
                  no2Options.map((option) => {
                    return (
                      <FormControlLabel value={option} control={<Radio />} label={option} onChange={() => {
                        setData({ ...data, No2: option })
                        setValue("No2", option, { shouldValidate: true })
                      }
                      } />
                    )
                  })
                }
              </RadioGroup>
            )}
          />
          <FormHelperText error>{errors.No2?.message}</FormHelperText>
        </FormControl>

        {/* No3 */}
        <FormControl component="fieldset" margin="normal" required>
          <FormLabel component="legend">このサービスをどこで知りましたか？</FormLabel>
          <Controller
            name="No3"
            control={control}
            render={({ field }) => (
              <Select {...field} onChange={(event) => {
                setData({ ...data, No3: event.target.value as typeof data.No3 })
                setValue("No3", event.target.value as any, { shouldValidate: true })
              }}>
                {
                  no3Options.map((option) => {
                    return (
                      <MenuItem value={option} children={option} />
                    )
                  })
                }
              </Select>
            )}
          />
          <FormHelperText error>{errors.No3?.message}</FormHelperText>
        </FormControl>

        {/* No4 */}
        <FormControl component="fieldset" margin="normal" required>
          <FormLabel component="legend">利用規約</FormLabel>
          <FormGroup>
            {no4Options.map((option) => {
              return (
                <Controller
                  name="No4"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={
                        <Checkbox {...field}
                          checked={data.No4?.includes(option)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              const no4 = isNil(data.No4) ? [option] : [...data.No4, option]
                              setData({ ...data, No4: no4 })
                              setValue("No4", no4, { shouldValidate: true })
                            } else {
                              const no4 = isNil(data.No4) ? [] : data.No4.filter((value) => value !== option)
                              setData({ ...data, No4: no4 })
                              setValue("No4", no4, { shouldValidate: true })
                            }
                          }} />
                      }
                      label={option}
                    />
                  )}
                />)
            })}
          </FormGroup>
          <FormHelperText error>{errors.No4?.message}</FormHelperText>
        </FormControl>
      </Box>
    </Box >
  )
}

export default InputForm